import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/element-variables.scss'
import 'lib-flexible/flexible'
import '@/plugins/flexible'
import '@/plugins/fontSize'
import '@/assets/css/normalize.css'
import "@/assets/css/public.scss"
import Layout from "@/components/Layout.vue"
import LayoutItem from "@/components/LayoutItem.vue"
import MyBreadcrumb from '@/components/MyBreadcrumb.vue'
import * as Common from './utils/common'
import InView from 'in-view'
Vue.config.productionTip = false
import Meta from 'vue-meta';
// 使用vue-meta
Vue.use(Meta);
Vue.prototype.inView = InView
// echarts 字体大小、边距适配
import { fitChartSize } from "@/utils/chart"
Vue.prototype.$fitChartSize = fitChartSize
Vue.prototype.$message = Element.Message
// 全局过滤器
import * as filters from '@/filters'

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.use(Element)
Vue.component('MyBreadcrumb', MyBreadcrumb);
Vue.component("Layout", Layout)
Vue.component("Litem", LayoutItem)
window.addEventListener("beforeunload", () => {
  store.dispatch("menu/resetMenuList")
})
// 全局方法注册
Object.keys(Common).forEach(key => {
  Vue.prototype[key] = Common[key]
})

const bus = new Vue();
Vue.prototype.$bus = bus;
new Vue({
  router,
  store,
  metaInfo() {
    return {
      title: this.$store.state.global.metaInfo.title,
      meta: [
        {
          name: "keywords",
          content: this.$store.state.global.metaInfo.keywords
        }, {
          name: "description",
          content: this.$store.state.global.metaInfo.description
        }
      ]
    }
  },

  render: h => h(App)
}).$mount('#app')
